<template>
  <div>
    <b-card>
      <div class="d-flex justify-content-between align-items-center mb-1">
        <h4 class="mb-0">
          Usuários
        </h4>

        <div class="d-flex align-items-center">
          <b-input-group
            size="sm"
            class="mr-1"
          >
            <b-input-group-prepend is-text>
              <feather-icon icon="SearchIcon" />
            </b-input-group-prepend>
            <b-form-input
              v-model="search"
              placeholder="Buscar por nome ou email"
            />
          </b-input-group>

          <b-button
            variant="primary"
            size="sm"
            @click="showCreateModal = true"
          >
            <feather-icon
              icon="PlusIcon"
              class="mr-50"
            />
            Novo Usuário
          </b-button>
        </div>
      </div>

      <b-table
        :items="filteredUsers"
        :fields="fields"
        responsive
        hover
        bordered
        small
        class="mb-2"
      >
        <template #cell(actions)="row">
          <b-button
            size="sm"
            variant="outline-primary"
            class="mr-1"
            @click="editUser(row.item)"
          >
            <feather-icon icon="Edit2Icon" />
          </b-button>
          <b-button
            size="sm"
            variant="outline-danger"
            @click="deleteUser(row.item)"
          >
            <feather-icon icon="Trash2Icon" />
          </b-button>
        </template>
      </b-table>

      <b-pagination
        v-model="currentPage"
        :total-rows="filteredUsers.length"
        :per-page="perPage"
        align="center"
        size="sm"
      />
    </b-card>

    <ModalCriarUsuario
      :visible="showCreateModal"
      @close="showCreateModal = false"
      @created="adicionarUsuario"
    />

  </div>
</template>

<script>
import attendents from '@/functions/basics/attendents'
import ModalCriarUsuario from './CreateUser.vue'
import { deleteAtendente } from '../../functions/basics/user'

export default {
  components: { ModalCriarUsuario },
  data() {
    return {
      showCreateModal: false,
      users: [],
      search: '',
      fields: [
        { key: 'nome', label: 'Nome' },
        { key: 'email', label: 'Email' },
        { key: 'criado', label: 'Criado em' },
        { key: 'actions', label: 'Ações', class: 'text-center' },
      ],
      currentPage: 1,
      perPage: 5,
      showCreateModal: false,
      form: {
        nome: '',
        email: '',
        senha: '',
      },
      loading: false,
    }
  },
  computed: {
    filteredUsers() {
      const term = this.search.toLowerCase()
      return this.users.filter(user => user.nome.toLowerCase().includes(term)
          || user.email.toLowerCase().includes(term))
    },
  },
  created() {
    this.attendents()
  },
  methods: {
    async attendents() {
      const usuarios = await attendents()
      this.users = [
        ...usuarios.map(usuario => ({
          id: usuario.id,
          nome: usuario.name,
          email: usuario.email,
          criado: usuario.created_at,
        })),
      ]
      console.log(usuarios)
    },
    resetForm() {
      this.form = { nome: '', email: '', senha: '' }
    },
    adicionarUsuario(novo) {
      this.users.push(novo)
      this.$bvToast.toast('Usuário criado com sucesso!', {
        title: 'Sucesso',
        variant: 'success',
        solid: true,
      })
    },
    editUser(user) {
      this.$bvToast.toast(`Editar usuário: ${user.nome}`, {
        title: 'Editar',
        variant: 'info',
        solid: true,
      })
    },
    deleteUser(user) {
      console.log(user)
      this.$bvModal.msgBoxConfirm(`Tem certeza que deseja excluir ${user.nome}?`, {
        title: 'Confirmação',
        okVariant: 'danger',
        okTitle: 'Excluir',
        cancelTitle: 'Cancelar',
        footerClass: 'p-2',
        centered: true,
      }).then(async value => {
        if (value) {
          await deleteAtendente(user.id)

          this.users = this.users.filter(u => u.id !== user.id)
          this.$bvToast.toast('Usuário excluído com sucesso!', {
            title: 'Excluído',
            variant: 'success',
            solid: true,
          })
        }
      })
    },
  },
}
</script>
